import pluralize from 'pluralize'
import React, { useState } from 'react'
import Select from "react-select"

import { useListData, usePet, useToggle } from '../../modules'

import Modal from "../reusable/modal"
import Ingredients from './ingredients'

const AddVariant = ({ toggle, visible, item: itm, onPerform }) => {
    const [ingredients, setIngredients] = useState([])
    const [invRef, setInvRef] = useState(null)
    const [name, setName] = useState(null)
    const [conversionRate, setConversionRate] = useState('1')
    const [price, setPrice] = useState(null)
    const [form, setForm] = useState()
    const [string, setString] = useState('')
    

    const [{ loading: invLoading, fetch: fetchInvItems }, { list: items = [] }] = useListData('inventoryItems', { string }, { notify: true }, 'items')

    const [ingredientsModal, toggleIngredientsModal] = useToggle()
    
    const search = str => {
        if (str?.trim()?.length > 2) {
            setString(str)
            fetchInvItems()
        }
    }

    const modify = e => {
        switch (e.target.name) {
            case 'name':
                setName(e.target.value)
                break

            case 'price':
                setPrice(e.target.value)
                break

            case 'conversion-rate':
                setConversionRate(e.target.value)
                break

            default:
                break
        }
    }

    const deleteIngredient = i => {
        let temp = [...ingredients]
        temp = temp.filter((_, index) => i !== index)

        setIngredients(temp)
    }

    const onComplete = ({}, notif, ops) => {
        onPerform()
        notif('Variant has been added', ops('success'))
        
        setTimeout(toggle, 300)
    }
    
    const [, { list: forms }] = useListData('inputForms', { string: '' }, { notify: true, manual: false }, 'forms', 100)

    const [{ loading }, execute] = usePet('addVariantToSaleItem', {
        id: itm?._id, 
        name, 
        price, 
        form: form?.value,
        ref: invRef ? invRef?.value : null, 
        ingredients, 
        conversionRate
    }, { notify: true, hasFile: true, callback: onComplete, manual: true, load: { msg: 'Adding variant...' } })

    return (
        <Modal
            w={ 400 }
            title="Add Variant"
            toggle={toggle}
            visible={visible}>
            <Ingredients
                ingredients={ingredients}
                onSave={setIngredients}
                visible={ingredientsModal}
                toggle={toggleIngredientsModal} />
            <div className="w-full bg-white">
                <div className="flex flex-wrap -mx-3 mb-6">
                    {
                        itm?.type === 'Sale Item' &&
                        <>
                            <div className="w-full px-3 mb-3 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Inventory Item
                                </label>
                                <Select
                                    isLoading={invLoading}
                                    loadingMessage={string => `Searching for "${string?.inputValue}"`}
                                    onInputChange={search}
                                    value={invRef}
                                    onChange={ val => {
                                        setInvRef(val)
                                        setName(val.name)
                                    }}
                                    options={items.map(item => ({ label: item.name, value: item._id, ...item }))}
                                    placeholder="Search for inventory item" />
                                <p className="text-gray-500 text-xs italic">Which inventory item does it refer to?</p>
                            </div>
                            <div className="w-full px-3 mb-3 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Conversion Rate
                                </label>
                                <input
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                    id="grid-conversion-rate"
                                    type="text"
                                    name="conversion-rate"
                                    value={conversionRate}
                                    onChange={modify}
                                    placeholder="1/2" />
                            </div>
                        </>
                    }
                    <div className="w-full px-3 mb-3 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Item Name
                        </label>
                        <input
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            id="grid-name"
                            type="text"
                            name="name"
                            value={name}
                            onChange={modify}
                            placeholder="Plain Fries" />
                    </div>
                    <div className="w-full px-3 mb-3 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Item Price
                        </label>
                        <input
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            id="grid-price"
                            name="price"
                            type="number"
                            value={price}
                            onChange={modify}
                            placeholder="XXXX" />
                    </div>
                    {
                        itm?.type === 'Service' &&
                        <div className="w-full px-3 mb-3 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-username">
                                Input Form
                            </label>
                            <Select
                                value={ form }
                                className="mb-3"
                                options={ forms.map(frm => ({ value: frm._id, label: frm.name })) }
                                onChange={ setForm }
                                placeholder="Select Input Form" />
                        </div>
                    }
                    {
                        itm?.type === 'Prepared Item' &&
                        <div className="w-full px-3 mb-3 md:mb-0">
                            <div className="font-bold mt-3">
                                <div className="flex justify-between items-center">
                                    <p className="font-bold my-3">Ingredients</p>
                                    <button onClick={toggleIngredientsModal} className="btn hisani-btn-green-light text-white my-3">
                                        <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                                            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                        </svg>
                                        <span className="hidden xs:block ml-2">Add</span>
                                    </button>
                                </div>
                                {
                                    ingredients.length > 0 ?
                                        <table className="table-auto w-full mb-3">
                                            {/* Table header */}
                                            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                                <tr>
                                                    <th className="p-2">
                                                        <div className="font-semibold text-left">No</div>
                                                    </th>
                                                    <th className="p-2">
                                                        <div className="font-semibold text-left">Selected</div>
                                                    </th>
                                                    <th className="p-2">
                                                        <div className="font-semibold text-left">Quantity</div>
                                                    </th>
                                                    <th />
                                                </tr>
                                            </thead>
                                            {/* Table body */}
                                            <tbody className="text-sm font-medium divide-y divide-gray-100">
                                                {
                                                    ingredients.map((ingredient, key) =>
                                                        <tr>
                                                            <td className="p-2 text-left">{key + 1}</td>
                                                            <td className="p-2 text-left">{ingredient.name}</td>
                                                            <td className="p-2 text-left">{ingredient.qty} {pluralize(ingredient.issuedIn, ingredient.qty)}</td>
                                                            <td onClick={() => deleteIngredient(key)} className="p-2 text-left text-red-500 cursor-pointer">X</td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    :
                                        <div className="text-center my-4">
                                            <h3>Please click above to add ingredients</h3>
                                        </div>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
            <div className="flex justify-end">
                <button onClick={ execute } type="submit" className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
            </div>
        </Modal>
    )
}

export default AddVariant